































































































import { Component, Vue } from 'vue-property-decorator';

import { UserPage, UserService, curUserService } from '@/services/UserService';
import { DateTime } from 'luxon';

import Loading from '@/components/Loading.vue';
import VueError from '@/components/VueError.vue';
import UserRow from '@/components/access/UserRow.vue';
import UserRowMobile from '@/components/access/UserRowMobile.vue';
import CreateUser from '@/components/access/CreateUser.vue';
import EditUser from '@/components/access/EditUser.vue';
import { User } from '@/types/core';
import PageNav from "@/components/PageNav.vue";
import SearchBox from "@/components/SearchBox.vue";

import tippy from 'tippy.js'
import {curPref} from "@/services/Preferences";
import NumEntries from '@/components/NumEntries.vue';

import { CsvUtil } from '@/util/CsvUtil';
import moment from 'moment';
import fileDownload from 'js-file-download';
import _ from 'lodash';


@Component({
  components: {
    Loading,
    VueError,
    UserRow,
    UserRowMobile,
    CreateUser,
    EditUser,
    PageNav,
    SearchBox,
    NumEntries
  },
})
export default class Users extends Vue {

  // our model
  dateTime = DateTime;

  error:string = '';

  status:'view-all'|'create'|'edit'|'change-password'|'delete' = 'view-all';

  pageSize = 20;
  curOrderBy:any = 'email';
  curAscDesc:any = 'asc';
  searchTerm = curPref.retrieve('v3-users-search-term', '');

  httpBusy:boolean = true;
  pageList:UserPage[] = [];
  curPage:UserPage = {} as UserPage;
  
  selectedUser:User = {} as User;
  reqNo:number = 0;

  public $refs!: {
    'search-box': SearchBox
  };

  // internal dependencies
  // private coreClient:CoreClient = curCoreClient;
  private userService:UserService = curUserService;
  private csvUtil:CsvUtil = new CsvUtil();
  
  mounted() {
    tippy('[data-tippy-content]');
    this.refreshData();
  }

  changeStatus(newStatus:'view-all'|'create'|'edit'|'change-password'|'delete', selectedUser?:User) {
    
    this.status = newStatus;

    if(newStatus === 'view-all')
      this.refreshData();

    if(selectedUser)
      this.selectedUser = selectedUser;
  }

  async refreshData() {

    // TODO: support more than 1000 users
    this.error = '';
    this.httpBusy = true;

    // prevents unwanted effects from race conditions now the search bar hangs around
    const currentReq:number = this.reqNo + 1;
    this.reqNo = currentReq;

    const reply = await this.userService.getUsers({
        orderBy:this.curOrderBy,
        ascDesc:this.curAscDesc,
        pageSize:this.pageSize,
        filter: this.searchTerm})

    // if this request has not been superceded then continue
    if (currentReq !== this.reqNo){
      return
    }

    this.httpBusy = false;

    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.error = `Unable to retrieve user list: ${reply.errorMsg}`;

    this.pageList = reply.userPageList as UserPage[];

    // we set the current page
    if(this.pageList.length > 0)
      this.curPage = this.pageList[0];
  }

  newSearchText(newSearchText:string) {

    curPref.store('v3-users-search-term', newSearchText);
    this.searchTerm = newSearchText;
    this.refreshData();
  }

  exportList() {

    let allUserList = _.flatten(this.pageList.map(page => page.userList))
      
    let csvExport = this.csvUtil.userListToCsv(allUserList);

    let filename = `export-users-${moment().toISOString(true)}.csv`;

    fileDownload(csvExport, filename);
  }

  get showPageNav():boolean {
    return !this.httpBusy && this.pageList.length > 0;
  }

  get showUserRows():boolean {
    return !this.httpBusy && this.pageList.length > 0 && this.error === '';
  }

  get showNoMatches():boolean {
    return !this.httpBusy && this.pageList.length === 0 && this.searchTerm !== '' && this.error === '';
  }

  get showNoApiKeys():boolean {
    return !this.httpBusy && this.pageList.length === 0 && this.searchTerm === '' && this.error === '';
  }
  
  get numEntries():number {
    return this.pageList.map(page => page.userList.length).reduce((acc, current) => acc+current, 0);
  }

  get showNumEntries():boolean {
    return !this.httpBusy;
  }

  get numEntriesExactNumber():boolean {
    return this.searchTerm === '';
  }

}
